// strips html tags and trims whitespace for safe text rendering
const TAG_RE = /<[^>]*>/g;

export function sanitizeText(raw) {
  if (!raw || typeof raw !== "string") return "";
  return raw.replace(TAG_RE, "").trim();
}

export function sanitizeForDisplay(raw) {
  if (!raw || typeof raw !== "string") return "—";
  const clean = raw.replace(TAG_RE, "").trim();
  return clean || "—";
}
